/** 弹窗内 Select / Dropdown 挂载到 body，避免下拉列表撑开 modal 产生滚动条 */
export function getModalPopupContainer(): HTMLElement {
  return document.body;
}
